// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Rrpt","selected":"Chip_selected__3qU6g"};